import React, { useEffect, useState } from "react";
import CompanyPicker from "./CompanyPicker";
import { getCompany, onCompanyChange } from "../../util/accounting/company";

/**
 * Stands in front of every accounting page: no company open, no books shown.
 *
 * Guarding here rather than on each page means a page cannot be reached by
 * typing its URL before a company has been chosen, and no page has to remember
 * to check. The same guard is what closing a company runs through — clearing
 * the choice makes every accounting page fall back to the picker on the spot.
 *
 * Opening or closing a company is listened for rather than routed around, so
 * the swap happens wherever in accounting you happen to be standing.
 */
export default function CompanyGate({ children }) {
  const [company, setCompanyState] = useState(getCompany);

  useEffect(() => onCompanyChange(() => setCompanyState(getCompany())), []);

  if (!company) return <CompanyPicker />;

  // Remounting the tree on a company change is deliberate: every page holds
  // figures loaded from the previous company, and showing those under a new
  // company's name for even one frame would be worse than a brief reload.
  return <React.Fragment key={company.id}>{children}</React.Fragment>;
}
